import React, { useState, useEffect } from "react";
import { Div } from "@components/Generics.react";
import "@styles/components.scss";

const Countdown = (props) => {
    const {
        initialSeconds = 60,
        color,
        onZero,
        inline = false,
        showMinutes = false,
        localStore,
    } = props;
    const [seconds, setSeconds] = useState(initialSeconds);

    useEffect(() => {
        if (localStore != null) {
            const savedTime = parseInt(
                localStorage.getItem(`timer-${localStore}`),
                0
            );
            if (savedTime < initialSeconds) setSeconds(savedTime);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (seconds > 0) {
            const interval = setInterval(() => {
                let newTime = seconds - 1;
                if (localStore != null) {
                    localStorage.setItem(`timer-${localStore}`, newTime);
                }
                setSeconds(newTime);
            }, 1000);

            return () => clearInterval(interval);
        } else {
            if (onZero) onZero();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seconds]);

    // Function to format time in minutes:seconds
    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        if (hours > 0) {
            return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
                .toString()
                .padStart(2, "0")}`;
        } else {
            return `${minutes}:${seconds.toString().padStart(2, "0")}`;
        }
    };

    if (inline)
        return (
            <Div flex fluid spaceBetween>
                {showMinutes ? formatTime(seconds) : seconds}
                <Div
                    inline-block
                    pureCircle
                    wd="10px"
                    ht="10px"
                    className="quo-pulse-dot"
                />
            </Div>
        );
    else
        return (
            <div className="quo-countdown">
                {seconds > 0 && (
                    <div
                        className="quo-pulse"
                        style={{ backgroundColor: color, opacity: 0.75 }}
                    ></div>
                )}
                {showMinutes ? formatTime(seconds) : seconds}
            </div>
        );
};

export default Countdown;
